export default "__VITE_ASSET__DvfnhEoA__"